define("preview-grid/components/share-plan-upgrade-modal", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @showUpgradeModal}}
    <Shared::Modal @close={{@closeModal}} {{will-destroy @closeModal}} as |modal|>
      <modal.card @portrait={{true}}>
        <modal.card-header>
          <p class="o--modalHeader__title">{{t "preview_grid.upgrade_modal.title"}}</p>
        </modal.card-header>
        <modal.card-body class="u--p__t__0">
          <p>{{t (concat "preview_grid.upgrade_modal.description" (if @currentAccount.canTrialPlan "_trial"))}}</p>
          <img
            alt={{t "preview_grid.share_plan.intro"}}
            class="o--media u--m__t__lg u--m__b"
            src="/assets/images/img--upgrade--shareCalendar.png"
          />
        </modal.card-body>
        <modal.card-footer>
          <Shared::Button::Upgrade
            @additional="block"
            @feature="shareCalendar"
            @location="shared instagram plan"
            @size="large"
            @text={{t "shared_phrases.upgrade_plan"}}
            @trialText={{t "preview_grid.upgrade_modal.button_trial"}}
          />
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  */
  {
    "id": "u8exk5fd",
    "block": "[[[41,[30,1],[[[1,\"  \"],[8,[39,1],[[4,[38,2],[[30,2]],null]],[[\"@close\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,3,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,3],[\"preview_grid.upgrade_modal.title\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,3,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[12],[1,[28,[35,3],[[28,[37,4],[\"preview_grid.upgrade_modal.description\",[52,[30,4,[\"canTrialPlan\"]],\"_trial\"]],null]],null]],[13],[1,\"\\n        \"],[10,\"img\"],[15,\"alt\",[28,[37,3],[\"preview_grid.share_plan.intro\"],null]],[14,0,\"o--media u--m__t__lg u--m__b\"],[14,\"src\",\"/assets/images/img--upgrade--shareCalendar.png\"],[12],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,3,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,5],null,[[\"@additional\",\"@feature\",\"@location\",\"@size\",\"@text\",\"@trialText\"],[\"block\",\"shareCalendar\",\"shared instagram plan\",\"large\",[28,[37,3],[\"shared_phrases.upgrade_plan\"],null],[28,[37,3],[\"preview_grid.upgrade_modal.button_trial\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[]],null]],[\"@showUpgradeModal\",\"@closeModal\",\"modal\",\"@currentAccount\"],false,[\"if\",\"shared/modal\",\"will-destroy\",\"t\",\"concat\",\"shared/button/upgrade\"]]",
    "moduleName": "preview-grid/components/share-plan-upgrade-modal.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});